<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/34Fy0G/tc-custom/9780795338557.jpg?1708750904120" alt="This image is the cover for the book Hold the Dream, The Harte Family Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hold the Dream, The Harte Family Saga
      </h1>
      <p class="bookDescription body article font2">
        <b>A young woman inherits a business empire in this sequel to <i>A Woman of Substance</i>, book two in the #1 <i>New York Times</i>–bestselling author’s Harte Family Saga.</b><br/>  <br/> Nearing retirement, Emma Harte is preparing to leave her retail empire, Harte Enterprises, to her favorite grandchild, Paula McGill Fairley. She has only one request of Paula: “I charge you to hold my dream.”<br/>  <br/> Now Paula must navigate the cutthroat corporate waters of the business world while steering her course toward the happiness she longs for, and the legacy she herself will build. Emotionally rich and splendidly detailed, this sequel continues the story of the Hartes in magnificent style.<br/>  <br/> “Few novelists are as consummate as Barbara Taylor Bradford at keeping the reader turning the page.” —<i>The Guardian</i><br/>  <br/> “Another instant bestseller.” —<i>The Philadelphia Inquirer</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Taylor Bradford
      </h2>
      
      <p class="authorDescription body article">Barbara Taylor Bradford is a #1 <I>New York Times</I>&ndash;bestselling author. Born in Britain, she began her career as a typist at the <I>Yorkshire Evening Post</I> at the age of sixteen, later serving as the fashion editor of <I>Woman&#39;s Own Magazine</I> and a feature writer at the <I>London Evening News</I>. Her debut novel, <I>A Woman of Substance</I>, sold more than thirty&#160;million copies worldwide and became one of the top ten bestselling novels ever written. Bradford has written twenty-eight subsequent books that have sold over eighty-nine million copies in more than ninety&#160;countries around the world. Several of her novels have been made into television miniseries and movies. In 1999, she became the first living female author to be featured on a postage stamp; in 2003, she was awarded a place in the Writers&#39; Hall of Fame of America, and in 2007, she was inducted into the Order of the British Empire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fe710fe